import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppThunk } from '../../../store';
import axios from '../../../axios';
import { PropertyType } from '../../../shared/models/propertyType.enum';
import { ToastAnt } from '../../Shared/Toast/ToastAnt';

export type FindingTypePropertyTemplateType = {
  id: string | undefined;
  fullName: string;
  shortName: string;
  description: string;
  type: PropertyType | null;
  units: string;
  values: string;
  propertyId: string | null;
  canDelete: boolean;
};

type State = {
  findingTypePropertyTemplates: Array<FindingTypePropertyTemplateType>;
  loading: boolean;
  modalVisible: boolean;
};

const findingTypePropertyTemplateSlice = createSlice({
  name: 'findingTypePropertyTemplate',
  initialState: {
    findingTypePropertyTemplates: Array<FindingTypePropertyTemplateType>(),
    loading: false,
    modalVisible: false
  },
  reducers: {
    fetchFindingTypePropertyTemplatesStarted(state) {
      state.loading = true;
    },
    fetchFindingTypePropertyTemplatesSuccess(state, action: PayloadAction<Array<FindingTypePropertyTemplateType>>) {
      state.findingTypePropertyTemplates = action.payload;
      state.loading = false;
    },
    fetchFindingTypePropertyTemplatesFailed(state) {
      state.loading = false;
    },
    showModal(state, action: PayloadAction<boolean>) {
      state.modalVisible = action.payload;
    }
  }
});

export const {
  fetchFindingTypePropertyTemplatesStarted,
  fetchFindingTypePropertyTemplatesSuccess,
  fetchFindingTypePropertyTemplatesFailed,

  showModal
} = findingTypePropertyTemplateSlice.actions;

export const fetchFindingTypePropertyTemplates = (): AppThunk => async dispatch => {
  try {
    dispatch(fetchFindingTypePropertyTemplatesStarted);
    const response = await axios.get(`/findingTypePropertyTemplates`);
    dispatch(fetchFindingTypePropertyTemplatesSuccess(response.data));
  } catch {
    dispatch(fetchFindingTypePropertyTemplatesFailed);
  }
};

export const saveFindingTypePropertyTemplate =
  (findingTypePropertyTemplate: FindingTypePropertyTemplateType): AppThunk =>
  async dispatch => {
    try {
      if (findingTypePropertyTemplate.id) {
        await axios.put(`/findingTypePropertyTemplates`, {
          id: findingTypePropertyTemplate.id,
          fullName: findingTypePropertyTemplate.fullName,
          shortName: findingTypePropertyTemplate.shortName,
          description: findingTypePropertyTemplate.description,
          type: PropertyType[findingTypePropertyTemplate.type!],
          units: findingTypePropertyTemplate.units,
          values: findingTypePropertyTemplate.values
        });
      } else {
        await axios.post(`/findingTypePropertyTemplates`, {
          fullName: findingTypePropertyTemplate.fullName,
          shortName: findingTypePropertyTemplate.shortName,
          description: findingTypePropertyTemplate.description,
          type: PropertyType[findingTypePropertyTemplate.type!],
          units: findingTypePropertyTemplate.units,
          values: findingTypePropertyTemplate.values
        });
      }
      dispatch(fetchFindingTypePropertyTemplates());
      ToastAnt('Saved.');
    } catch (error) {
      ToastAnt('An error occured.');
    }
  };

export const deleteFindingTypePropertyTemplate =
  (id: string): AppThunk =>
  async dispatch => {
    try {
      await axios.delete(`/findingTypePropertyTemplates/${id}`);
      dispatch(fetchFindingTypePropertyTemplates());
      ToastAnt('Deleted.');
    } catch (error) {
      ToastAnt('An error occured.');
    }
  };

export default findingTypePropertyTemplateSlice.reducer;
